<template>
<div>
  <v-layout justify-center>
    <v-img
        :src="require('@/assets/ip_page-input_bg.png')"
        :contain="$vuetify.breakpoint.mdAndUp"
        :cover="$vuetify.breakpoint.smAndDown"
        max-width="1240px"
        width="100%"
        class="input-head"
      >
      <v-container fill-height grid-list-xl>
        <v-layout align-center>
          <v-flex xs8 sm9>
            <h2 style="font-weight: 500;">Für dich</h2>
            <p>Schenke jedem Tag ein wenig Aufmerksamkeit.</p>
            <v-btn class="ma-0 elevation-0" color="warning" :to="{ name: 'achtsamkeitskarten' }">
              zu den Achtsamkeitskarten
              <v-icon right>keyboard_arrow_right</v-icon>
            </v-btn>  
          </v-flex>
          <v-flex xs4 sm3>
            <img width="100%" class="card-img" src="@/assets/card-pack.png" alt=""/>
          </v-flex>
        </v-layout>
      </v-container>
    </v-img>
  </v-layout>
  <v-container grid-list-xl>
    <!-- <v-layout wrap row>
      <v-flex xs12 class="py-10">
        <h1>Achtsamkeit</h1>
        <p>
          Unsere erste Säule beschäftigt sich mit dem Förderung des eigenen inneren Potenzials.<br>
          Mit Übungen und Anregungen wird deine unbewusste Intelligenz gefördert.
        </p>
      </v-flex>
    </v-layout> -->
    <v-layout>
      <v-flex sm8 offset-sm2 style="text-align: center; margin: 50px auto;">
        <h4>Ich möchte euren Podcast hören!</h4>
        <p>Jede zweite Woche sprechen wir über interessante Themen aus dem Bereich Intuition, Achtsamkeit und Selbstorganisation.</p>
        <v-btn class="elevation-0" color="warning" :to="{ name: 'podcast' }">zum Podcast<v-icon right>keyboard_arrow_right</v-icon></v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <app-weekly/>
      </v-flex>
      <v-flex>
        <app-emailinformation/>
      </v-flex>
    </v-layout>
  </v-container>
</div>
</template>

<script>
export default {
  data () {
    return {
      links: [
        {
          src: 'https://gallery.mailchimp.com/80a2795ef220b97aa8cfac873/images/b6bfc40e-7af4-4d8d-8815-ae1801ad5d46.jpg',
          link: 'achtsamkeitskarten',
          linkTitle: 'zu den Karten',
          title: 'Achtsamkeitskarten',
          description: 'Some description </br> with a BR tag'
        },
        {
          src: 'https://gallery.mailchimp.com/80a2795ef220b97aa8cfac873/images/3345f11c-6a94-49ea-9d3c-193208423f93.jpg',
          link: 'übungen',
          linkTitle: 'zu den Übungen',
          title: 'Übungen',
          description: 'Some description </br> with a BR tag'
        }
      ]
    }
  }
}
</script>

<style lang="scss">
  .card-img {
    @media screen and (min-width: 960px) {
      position: absolute;
      bottom: 0px;
      right: 20px;
      width: 200px;
    }
  }
  .input-head .v-image__image {
    opacity: 0.5;
  }
</style>

